// 入住api
import http from './http';

// const getService = (requestUrl, params?, config?) => {
//   return http({
//     ...config,
//     method: 'GET',
//     url: requestUrl,
//     params,
//   });
// };

const postService = (requestUrl, data?, config?) => {
  return http({
    ...config,
    method: 'POST',
    url: requestUrl,
    data,
  });
};

// 校验入住信息
const preCheckIn = (data) => postService('/check-in/check', data);

// 创建入住单
const createCheckIn = (data) => postService('/check-in/create', data);

// 续住原信息
const getRenewalInfo = (data) => postService('/check-in/extension/detail', data);

// 续住
const submitRenewalInfo = (data) => postService('/check-in/extension/submit', data);

// 订单原信息
const getCheckInOrderInfo = (data) => postService('/reservation/transfer/detail', data);

// 预订入住检查
const checkCheckInReserve = (data) => postService('/reservation/transfer/check', data);

// 预订转入住
const submitCheckInByReserve = (data) => postService('/reservation/transfer/create', data);

// 退房原信息
const getCheckOutInfo = (data) => postService('/check-in/check-out/info', data);

// 退房
const createCheckOut = (data) => postService('/check-in/check-out/submit', data);

// 退房校验
const checkOutValidate = (data) => postService('/check-in/check-out/validate', data);

// 入住换房
const submitCheckInExchange = (data) => postService('/rooms/change/check-in/submit', data);

// 追加入住
const submitCheckInAppend = (data) => postService('/check-in/append', data);

// 获取可续住的直连预订列表
const getAvailableZLOrderList = (data) => postService('/zl-extension/available', data);

// 续住直连预订详情
const getRenewalZLOrderDetail = (data) => postService('/zl-extension/zl-detail', data);

// 续住直连预订提交
const submitRenewalZLOrder = (data) => postService('/zl-extension/zl/submit', data);

// 批量获取子单信息
const batchGetOrderInfo = (data) => postService('/sub/order/batch/recs', data);

// 获取可续住订单列表
const getExtensionOrderList = (data) => postService('/extension/zl/orders/v2', data);

// 获取续住订单信息
const getExtensionOrderSummary = (data) => postService('/extension/zl/orders/summary', data);

export default {
  preCheckIn,
  createCheckIn,
  createCheckOut,
  getRenewalInfo,
  getCheckOutInfo,
  submitRenewalInfo,
  getCheckInOrderInfo,
  checkCheckInReserve,
  submitCheckInByReserve,
  submitCheckInExchange,
  submitCheckInAppend,
  getAvailableZLOrderList,
  getRenewalZLOrderDetail,
  submitRenewalZLOrder,
  batchGetOrderInfo,
  getExtensionOrderList,
  getExtensionOrderSummary,
  checkOutValidate,
};
